module.exports = __webpack_public_path__ + "img/grid-diagnosis.625b8706.webp";